import type { ParentState, ReviewContext } from "@hopper-b2b/checkout";

export interface TermsAndConditionsContext {
  accepted: boolean;
}

export const termsAndConditionsStep = "termsAndConditionsStep";

export interface PartialParentContextWithTermsAndConditions {
  [ParentState.review]: ReviewContext & {
    [termsAndConditionsStep]: TermsAndConditionsContext;
  };
}
